var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 808,
    viewBox: "0 0 747 808",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.5L514.8 622.5L373.1 807.9L231.5 622.5L62.7001 592.5L89.8002 377.2L0.100098 82.4004L231.5 131.8L373.1 0L514.8 131.8L746.2 82.4004L656.4 377.2L683.5 592.5Z",
    fill: "#7D87C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 396.1C383.538 396.1 392 387.638 392 377.2C392 366.762 383.538 358.3 373.1 358.3C362.662 358.3 354.2 366.762 354.2 377.2C354.2 387.638 362.662 396.1 373.1 396.1Z",
    fill: "#17B7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 8.90039V377.2L231.5 131.8L373.1 8.90039Z",
    fill: "#CAF4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 0V377.2L514.8 131.8L373.1 0Z",
    fill: "#3C2791"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.100098 82.4004L373.1 377.2H89.8002L0.100098 82.4004Z",
    fill: "#3C2791"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.100098 82.4004L201.9 241.9L373.1 377.2L231.5 131.8L0.100098 82.4004Z",
    fill: "#6847BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2002 588.1L373.1 377.2L231.5 622.5L116.9 599.1L69.2002 588.1Z",
    fill: "#A82BB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7002 592.5L373.1 377.2H89.8003L62.7002 592.5Z",
    fill: "#6847BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 807.9V377.2L514.8 622.5L373.1 807.9Z",
    fill: "#301872"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 791.1V377.2L231.4 622.5L373.1 791.1Z",
    fill: "#D152D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.5L373.1 377.2H656.4L683.5 592.5Z",
    fill: "#6847BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M672.2 584.7L667.7 500.1L559.6 506.6L672.2 584.7Z",
    fill: "#E096CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M683.5 592.5L373.1 377.2L514.8 622.5L683.5 592.5Z",
    fill: "#3C2791"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M733.2 92.7002L373.1 377.2L513.2 134.6L733.2 92.7002Z",
    fill: "#96B5E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M746.2 82.4004L373.1 377.2H656.4L746.2 82.4004Z",
    fill: "#3C2791"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 93.2002L139.3 192.4L121.7 112.4L13.7002 93.2002Z",
    fill: "#E096CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M640.3 166L677.3 308.6L746.2 82.4004L640.3 166Z",
    fill: "#301872"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8003 251.6L186.6 377.2H92.7002L54.8003 251.6Z",
    fill: "#C155C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 13.6001L508 139.1L511.8 142.6L516.9 141.5L731.7 95.7002L646.9 374.2L646.3 376.2L646.6 378.3L672.5 584.3L513 612.7L509.2 613.4L506.8 616.5L373.1 791.5L239.4 616.5L237 613.4L233.2 612.7L73.8 584.4L99.7 378.4L100 376.3L99.4 374.3L14.6 95.8003L229.4 141.6L234.5 142.7L238.3 139.2L373.1 13.6001ZM373.1 0L231.4 131.8L0 82.4004L89.7 377.1L62.7 592.5L231.4 622.5L373.1 807.9L514.8 622.5L683.5 592.5L656.5 377.1L746.2 82.4004L514.8 131.8L373.1 0Z",
    fill: "#6847BA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M574.3 601.8L513 612.7L509.2 613.4L506.8 616.5L486.6 642.9L496 647.2L514.8 622.5L572.3 612.3L574.3 601.8Z",
    fill: "#96B5E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M408 46.1001L488 120.5L489.4 108.2L414.9 38.8003L408 46.1001Z",
    fill: "#96B5E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.8 608.3L112.4 591.2L105.6 600.1L201.8 617.2C204.2 614.3 206.6 611.3 208.8 608.3Z",
    fill: "#96B5E2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M710.2 166.3L667 308.1L679 303.1L720.7 166L710.2 166.3Z",
    fill: "#96B5E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4 341.7L53.3 223L43 223.3L78.7 340.7L89.4 341.7Z",
    fill: "#96B5E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M549.9 259L422.3 185.3C407.4 176.7 390.4 172.1 373.2 172.1C356 172.1 339 176.7 324.1 185.3L196.5 259C186.5 264.8 180.3 275.5 180.3 287V358.5C180.3 384.1 190.8 408.6 209.1 426.3V431.5C209.1 468 228.7 502 260.2 520.2L373.2 585.5L486.2 520.2C518.6 501.5 536.7 468.2 537.3 426.3C555.7 408.5 566.1 384.1 566.1 358.5V287C566.1 275.5 559.9 264.8 549.9 259Z",
    fill: "#1C1128"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 172.2C390.3 172.2 407.3 176.8 422.2 185.4L549.8 259.1C559.8 264.9 566 275.6 566 287.1V358.6C566 384.2 555.5 408.7 537.2 426.4C536.6 468.3 518.6 501.6 486.1 520.3L373.1 585.6L260.1 520.3C228.6 502.1 209 468.1 209 431.6V426.4C190.6 408.6 180.2 384.2 180.2 358.6V287.1C180.2 275.6 186.4 264.8 196.4 259.1L324 185.4C338.9 176.7 355.9 172.2 373.1 172.2ZM373.1 162.2C354.1 162.2 335.4 167.2 319 176.7L191.4 250.4C178.3 257.9 170.2 272 170.2 287.1V358.6C170.2 385.3 180.7 411.2 199 430.5V431.6C199 471.7 220.5 509 255.1 528.9L368.1 594.2L373.1 597.1L378.1 594.2L491.1 528.9C525.6 509 545.4 474.2 547.1 430.6C565.5 411.3 576 385.2 576 358.5V287C576 271.9 567.9 257.9 554.8 250.3L427.2 176.6C410.8 167.2 392.1 162.2 373.1 162.2Z",
    fill: "#6847BA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.6 276.8L373.1 352.7L504.6 276.8L403.2 218.3C384.5 207.5 361.6 207.5 342.9 218.3L241.6 276.8Z",
    fill: "#698445"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 384.8L218.1 297.6V358.5C218.1 378.6 228.8 397.2 246.2 407.2L246.9 407.6V431.5C246.9 454.6 259.1 475.8 279 487.3L373 541.6L467 487.3C486.9 475.8 499.1 454.6 499.1 424.3V407.7L499.8 407.3C517.2 397.2 527.9 378.7 527.9 358.6V297.7L373.1 384.8Z",
    fill: "#6847BA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 384.8V541.6L467.1 487.3C487 475.8 499.2 454.6 499.2 424.3V407.7L499.9 407.3C517.3 397.2 528 378.7 528 358.6V297.7L373.1 384.8Z",
    fill: "#301872"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M518.1 314.8V358.6C518.1 375.1 509.2 390.4 495 398.7L494.3 399.1L489.3 402V407.8V424.5C489.3 449.8 479.9 468.6 462.2 478.8L373.2 530.2L284.2 478.8C267.5 469.2 257.1 451.1 257.1 431.7V407.7V401.9L252.1 399L251.4 398.6C237.1 390.4 228.3 375 228.3 358.5V314.7L368.4 393.5L373.3 396.3L378.2 393.5L518.1 314.8ZM528.1 297.7L373.1 384.9L218.1 297.7V358.6C218.1 378.7 228.8 397.3 246.2 407.3L246.9 407.7V431.6C246.9 454.7 259.1 475.9 279 487.4L373 541.7L467 487.4C486.9 475.9 499.1 454.7 499.1 424.4V407.7L499.8 407.3C517.2 397.2 527.9 378.7 527.9 358.6V297.7H528.1Z",
    fill: "#6847BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257 401.9L373.1 467.2V478.7L257 413.4V401.9Z",
    fill: "#3C2791"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M489.2 401.9L373.1 467.2V478.7L489.2 413.4V401.9Z",
    fill: "#6847BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M403.3 218.2C394 212.8 383.6 210.1 373.2 210.1V352.7L504.7 276.8L403.3 218.2Z",
    fill: "#1F4927"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 297.7L246.9 279.8L373.1 352.7L499.3 279.8L373.1 297.7Z",
    fill: "#143321"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 220.2C381.9 220.2 390.6 222.5 398.2 226.9L484.6 276.8L373.1 341.2L261.6 276.8L348 226.9C355.6 222.5 364.3 220.2 373.1 220.2ZM373.1 210.2C362.7 210.2 352.3 212.9 343 218.3L241.6 276.8L373.1 352.7L504.6 276.8L403.2 218.3C393.9 212.9 383.5 210.2 373.1 210.2Z",
    fill: "#2B5E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster2);
export default __webpack_public_path__ + "static/media/master-2.28571e465043a2524d6a8ad6cfaf224e.svg";
export { ForwardRef as ReactComponent };